import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ListaService } from '../../core/services/lista.service';
import { TomarListaDataSource } from './tomar-lista-data-source';
import { TomarListaCarga, TomarListaPersona } from './tomar-lista.model';

@Injectable()
export class TomarListaService extends TomarListaDataSource {
  private readonly lista = inject(ListaService);

  cargar(idLider?: string): Observable<TomarListaCarga> {
    return this.lista.planilla(idLider).pipe(
      map((planilla) => ({
        contexto: {
          celulaName: planilla.celulaName,
          abierta: planilla.abierta,
          mostrarLider: planilla.mostrarLider,
          elegirLider: planilla.elegirLider === true,
          lideres: planilla.lideres ?? [],
          idLider: planilla.idLider ?? null,
        },
        personas: planilla.personas.map((persona) => ({
          id: persona.id,
          nombre: persona.nombre,
          apellido: persona.apellido,
          miLider: persona.miLider,
          pasarLista: false,
          enMiCelula: true,
          nacimiento: persona.nacimiento,
          sexo: persona.sexo,
          asistencia: { celula: null, domingo: null },
        })),
      })),
    );
  }

  enviar(personas: TomarListaPersona[]): Observable<void> {
    return this.lista.enviarLote(
      personas.map((persona) => ({
        idUser: persona.id,
        celula: persona.asistencia.celula === true,
        domingo: persona.asistencia.domingo === true,
      })),
    );
  }

  override ultima(idLider?: string): Observable<string | null> {
    return this.lista.ultimaToma(idLider);
  }
}
